import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';
import styles from '../../style/rulesEngine';
import ActionRow from './ActionRow';

const ActionGroup = ({ actions, onActionChange, onActionRemove, onActionAdd, errors }) => {
  return (
    <View>
      {/* "Then Take these actions  [For Each Instance]" */}
      <View style={styles.whenRow}>
        <Text style={styles.whenWord}>Then</Text>
        <Text style={styles.whenSubText}>Take these actions</Text>
        <View style={styles.forEachBadge}>
          <Text style={styles.forEachBadgeText}>For Each Instance</Text>
        </View>
      </View>

      {/* Action rows — wrapped with decreasing zIndex for dropdown stacking */}
      {actions.map((action, i) => (
        <View key={i} style={{ zIndex: actions.length - i, position: 'relative' }}>
          <ActionRow
            action={action}
            index={i}
            onChange={onActionChange}
            onRemove={onActionRemove}
            isOnly={actions.length === 1}
            errors={errors}
          />
        </View>
      ))}

      {/* Centered + Add Action */}
      <View style={styles.addCenteredButton}>
        <TouchableOpacity onPress={onActionAdd} style={styles.addCenteredInner}>
          <Text style={styles.addCenteredText}>Add Action</Text>
          <i className="icon-plus" style={{ color: '#fff', fontSize: 45 }} />
        </TouchableOpacity>
      </View>

      {errors?.actions && (
        <Text style={styles.errorText}>{errors.actions}</Text>
      )}
    </View>
  );
};

ActionGroup.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onActionChange: PropTypes.func.isRequired,
  onActionRemove: PropTypes.func.isRequired,
  onActionAdd: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

export default ActionGroup;
